import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '../../components/Button';
import Title from '../../components/PageTitle';
import PagePath from '../../constants/PagePath';
import AdminLayout from '../../HOC/AdminLayout';
import { useGlobalState } from '../../hooks/useGlobalState';
import { getLink } from '../../utils';
import './AdminProductsNew.scss';
import AdminProductsNewForm from './components/AdminProductsNewForm';

export const AdminProductsNew = () => {
  const [{ company }] = useGlobalState();
  const [t] = useTranslation();
  const navigate = useNavigate();

  const redirectToProducts = () => {
    navigate(getLink(company, PagePath.ADMIN_PRODUCTS));
  };

  return (
    <AdminLayout>
      <div className="admin-products-new-title-wrapper">
        <Title text="Produkt hinzufügen" color="green" width="13%" />
        <Button
          className="admin-products-new-title-wrapper-button"
          variant="light"
          size="small"
          onClick={redirectToProducts}
          arrow="back"
        >
          {t('Zurück')}
        </Button>
      </div>
      <AdminProductsNewForm />
    </AdminLayout>
  );
};

export default AdminProductsNew;
